import { LoaderSpan } from "./Loader.style";

const Loader = ({ isSmall, isNoCenter }) => {
  return <LoaderSpan isSmall={isSmall} isNoCenter={isNoCenter} />;
};

export default Loader;
